/**
 * @generated SignedSource<<a9b62471ce29523412c79e09bd6d074d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditorPreferencesQueryFragment$data = {
  readonly confluenceEditorSettings: {
    readonly toolbarDockingInitialPosition: string | null;
  } | null;
  readonly " $fragmentType": "EditorPreferencesQueryFragment";
};
export type EditorPreferencesQueryFragment$key = {
  readonly " $data"?: EditorPreferencesQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorPreferencesQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EditorPreferencesQueryFragment",
  "selections": [
    {
      "concreteType": "ConfluenceEditorSettings",
      "kind": "LinkedField",
      "name": "confluenceEditorSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "toolbarDockingInitialPosition"
        }
      ]
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "c14a58c792cd6196c5f117a58ba70054";

export default node;
